import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetUnredactedIssuedCardRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetUnredactedIssuedCardResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getUnredactedIssuedCard = (request: GetUnredactedIssuedCardRequest, options?: CashRequestOptions) =>
  post<GetUnredactedIssuedCardRequest, GetUnredactedIssuedCardResponse>(
    '/2.0/cash/get-unredacted-issued-card',
    request,
    { ...options, rejectOnError: true }
  )
